import { render } from "./UpSelling.vue?vue&type=template&id=18bedb51&scoped=true"
import script from "./UpSelling.vue?vue&type=script&lang=js"
export * from "./UpSelling.vue?vue&type=script&lang=js"

import "./UpSelling.vue?vue&type=style&index=0&id=18bedb51&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bedb51"]])

export default __exports__